<template>
  <side-bar-menu width="310px">
    <v-tabs v-model="tab" background-color="transparent" height="25" slider-size="1" class="tabs" color="primary">
      <v-tab disabled class="font-weight-light" v-for="(item, index) in menuItems" :key="index" :to="item.link" dense>
        <v-icon v-if="item.icon" class="mr-2">{{ item.icon }}</v-icon>
        {{ item.title }}
      </v-tab>
    </v-tabs>

    <div class="side-menu-scroll">
      <v-card outlined class="pa-2 elevation-0 font-weight-bold">
        <v-card-title class="py-0 px-0 font-weight-bold">{{ $t('sideMenu.pairLabel') }}</v-card-title>
        <div class="d-flex justify-space-between align-center flex-gap-4">
          <v-card-subtitle class="mx-0 px-0 py-1 text--secondary">{{ $t('sideMenu.account') }}</v-card-subtitle>
          <v-select hide-details class="right-placeholder text-caption pb-0 mb-0" disabled dense outlined
            :placeholder="$t('sideMenu.accountPlaceholder')"></v-select>
        </div>
        <v-card-actions class="flex-grow-1 d-flex flex-column justify-center pa-0" style="
          width: 100%;
          border: 1px solid rgba(255, 255, 255, 0.5);
          border-bottom: none;
        ">
          <div class="text-center" style="font-size: 0.7rem">{{ $t('sideMenu.mockVolume') }}</div>
          <div class="text-center" style="font-size: 1rem">{{ $t('sideMenu.buy') }} EUR</div>
          <div class="text-center amount-size">
            1.21
            <span class="trade-price sell" style="line-height: 5rem">34</span>4
          </div>
          <div class="d-flex align-center justify-space-between mb-0" style="width: 100%">
            <v-progress-linear height="15" value="80"></v-progress-linear>
            <v-btn x-small icon><v-icon x-small>mdi-close</v-icon></v-btn>
          </div>
        </v-card-actions>

        <v-form>
          <v-card-actions class="d-flex flex-gap-2 py-1 px-0">
            <v-btn small outlined>{{ $t('sideMenu.swapLabel') }}</v-btn>
            <div style="border: 1px solid rgba(255, 255, 255, 0.5)" class="d-flex rounded-sm flex-grow-1 align-center">
              <v-btn small text>{{ $t('sideMenu.spotLabel') }}</v-btn>
              <v-text-field v-model="date" class="right-placeholder no-border" :placeholder="date"
                outlined readonly dense style="height: 35px" hide-details disabled />
            </div>
          </v-card-actions>

          <v-card-actions class="px-0">
            <div class="d-flex flex-gap-2 py-0" style="width: 100%">
              <v-btn class="elevation-0 rounded-sm" x-small color="primary">{{ $t('sideMenu.buy') }}</v-btn>
              <v-btn class="elevation-0 rounded-sm" x-small color="secondary">EUR</v-btn>
              <v-select class="right-placeholder" disabled style="height: 30px" hide-details
                placeholder="1,000,000" dense outlined />
            </div>
          </v-card-actions>

          <v-card-actions style="width: 100%" class="d-flex flex-column flex-grow-1 flex-gap-2 px-0">
            <div class="form-trade-reason">
              <h5 class="flex-grow-1 text--secondary">{{ $t('sideMenu.tradeReason') }}</h5>
              <v-select :placeholder="$t('sideMenu.tradeReasonPlaceholder')" class="right-placeholder flex-grow-1" dense hide-details outlined />
            </div>
            <div class="form-trade-reason">
              <h5 class="flex-grow-1 text--secondary">{{ $t('sideMenu.tradeReason') }}</h5>
              <v-select :placeholder="$t('sideMenu.tradeReasonPlaceholder')" class="right-placeholder flex-grow-1" disabled dense hide-details outlined />
            </div>
            <div class="form-trade-reason">
              <h5 class="flex-grow-1 text--secondary">{{ $t('sideMenu.tradeReason') }}</h5>
              <v-select :placeholder="$t('sideMenu.tradeReasonPlaceholder')" class="right-placeholder flex-grow-1" disabled dense hide-details outlined />
            </div>
          </v-card-actions>

          <v-card-actions class="d-flex flex-column pt-3 px-0">
            <div class="d-flex flex-column flex-gap-2 mb-2">
              <h5 class="text--secondary">{{ $t('sideMenu.dealSummary') }}</h5>
              <div style="font-size: 0.7rem" class="mb-2">
                {{ $t('sideMenu.accountPlaceholder') }} <span class="sell">{{ $t('sideMenu.buys') }}</span> EUR
                1,000,000.00 {{ $t('sideMenu.dealSummarySuffix') }}
              </div>
            </div>
            <div style="width: 100%; display: flex; flex-direction: column; gap: 0.3rem 0;">
              <v-text-field class="right-placeholder" disabled style="height: 35px" hide-details dense outlined placeholder="Remarks" />
              <v-text-field class="right-placeholder" disabled style="height: 35px" hide-details dense outlined placeholder="Remarks" />
              <v-text-field class="right-placeholder" disabled style="height: 35px" hide-details dense outlined placeholder="Remarks" />
              <v-text-field class="right-placeholder" disabled style="height: 35px" hide-details dense outlined placeholder="Remarks" />
            </div>
          </v-card-actions>

          <v-card-actions class="d-flex align-start flex-column px-0">
            <div class="d-flex flex-column flex-grow-1 flex-gap-2 pb-2">
              <h5 class="self-start text--secondary">{{ $t('sideMenu.settlementInstructions') }}</h5>
            </div>
            <div style="width: 100%; display: flex; flex-direction: column; gap: 0.3rem 0;">
              <div class="trade-form-grid text--secondary">
                <h5 class="font-weight-medium">{{ $t('sideMenu.details') }}</h5>
                <v-select hide-details class="right-placeholder font-weight-bold text-caption" outlined dense placeholder="45635" />

                <h5 class="font-weight-medium">{{ $t('sideMenu.buyAmount') }}</h5>
                <v-select hide-details class="right-placeholder font-weight-bold text-caption" outlined dense placeholder="1,000,000" />

                <h5 class="font-weight-medium">{{ $t('sideMenu.beneficiaryAccount') }}</h5>
                <v-select hide-details class="right-placeholder font-weight-bold text-caption" outlined dense placeholder="168432168432184" />

                <h5 class="font-weight-medium">{{ $t('sideMenu.beneficiaryName') }}</h5>
                <v-select hide-details class="right-placeholder font-weight-bold text-caption" outlined dense :placeholder="$t('sideMenu.beneficiaryNamePlaceholder')" />

                <h5 class="font-weight-medium">{{ $t('sideMenu.beneficiaryBank') }}</h5>
                <v-select hide-details class="right-placeholder font-weight-bold text-caption" outlined dense :placeholder="$t('sideMenu.beneficiaryBankPlaceholder')" />

                <h5 class="font-weight-medium">{{ $t('sideMenu.notifications') }}</h5>
                <v-switch dense inset />

                <h5 class="font-weight-medium">{{ $t('sideMenu.recipients') }}</h5>
                <v-select hide-details class="right-placeholder font-weight-bold text-caption" outlined dense :placeholder="$t('sideMenu.addRecipients')" />
              </div>
            </div>
          </v-card-actions>
        </v-form>
      </v-card>
    </div>
  </side-bar-menu>
</template>

<script>
import SideBarMenu from '@/components/layout/SideBarMenu.vue'

export default {
  components: { SideBarMenu },
  data() {
    return {
      tab: null,
      menuItems: [
        { title: this.$t('sideMenu.menu.rfs'), icon: 'mdi-chart' },
        { title: this.$t('sideMenu.menu.order'), icon: 'mdi-chart' },
      ],
      date: new Intl.DateTimeFormat('en-GB', {
        day: '2-digit', month: 'short', year: 'numeric',
      }).format(new Date()),
    }
  },
}
</script>

<style scoped>
.side-menu-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 4px 8px;
}
</style>
